.graphControlForm :global(.ant-form-item-label) {
  min-width: 125px;
}

.columnSelect {
  max-width: 800px;
}
